/**
 * React adapter for GTD domain
 * 
 * This is the main entry point for React applications
 * It exports hooks and providers for using GTD functionality
 */

// Provider
export { GTDProvider, useGTDClient } from './provider';

// Inbox hooks
export {
  useInboxItems,
  useInboxItem,
  useCaptureInboxItem,
  useClarifyInboxItem,
  useProcessInboxItem,
  useDeleteInboxItem,
} from './hooks/use-inbox';

// Project hooks
export {
  useProjects,
  useProject,
  useCreateProject,
  useCompleteProject,
  useDeferProject,
  useActivateProject,
  useCancelProject,
  useDeleteProject,
} from './hooks/use-projects';

// Next Action hooks
export {
  useNextActions,
  useNextAction,
  useActionsByProject,
  useActionsByContext,
  useContexts,
  useCreateNextAction,
  useAssignNextAction,
  useUnassignNextAction,
  useCompleteNextAction,
  useDeleteNextAction,
  useWeeklyReview,
} from './hooks/use-actions';